import { createFileRoute } from '@tanstack/react-router';

import { ToolFrame } from '../app/tool-frame.js';
import { ProjectAreaSection } from '../features/projects/detail/project-area/project-area-section.js';

export const Route = createFileRoute(
  '/_authed/teams/$teamId/projects/$projectId/project-area',
)({
  component: () => <ToolFrame toolSlug="project-area" Section={ProjectAreaSection} />,
});
